export default '/build/53fd5531.svg'